import { useActivePaymentProfile } from './use-active-payment-profile'
import { useGetPaymentProfiles } from './use-get-payment-profiles'

interface UseActivePaymentProfileNameParams {
  stoneAccountId: string
}

export function useActivePaymentProfileName({ stoneAccountId }: UseActivePaymentProfileNameParams) {
  const { activeProfileId } = useActivePaymentProfile()
  const { data: paymentProfiles = [] } = useGetPaymentProfiles({ stoneAccountId })
  const activeProfileName = paymentProfiles.find(profile => profile.id === activeProfileId)?.alias ?? ''

  return { activeProfileId, activeProfileName }
}
